import Polyglot from './polyglot';

const IDENT_RE = /^[a-zA-Z_][a-zA-Z0-9_]*$/;

function bindTranslate(poly) {
  return (key, second) => poly.t(key, second);
}

function installLocaleShortcut() {
  const cfg = window.__localeShortcutConfig || {};
  const defaultProduct = cfg.defaultProduct || 'app';
  const secondaryProducts = Array.isArray(cfg.secondaryProducts) ? cfg.secondaryProducts : [];

  const byProduct = window.langByProduct;
  const polys = {};

  if (byProduct && typeof byProduct === 'object') {
    for (const name of Object.keys(byProduct)) {
      const poly = new Polyglot({ phrases: byProduct[name] });

      poly.locale('default');
      polys[name] = poly;
    }
  }

  const appBundle = byProduct && byProduct[defaultProduct];
  const appPhrases = appBundle && typeof appBundle === 'object' ? appBundle : {};
  const appPoly = polys[defaultProduct] || new Polyglot({ phrases: appPhrases });

  appPoly.locale('default');

  window.__ = bindTranslate(appPoly);

  for (const product of secondaryProducts) {
    if (!IDENT_RE.test(product)) {
      continue;
    }

    const poly = polys[product];

    if (!poly) {
      continue;
    }

    window[`__${product}`] = bindTranslate(poly);
  }
}

export { installLocaleShortcut };
